// extracted by mini-css-extract-plugin
module.exports = {"authors":"MQA23","author-name":"_2KDZg"};